export enum Modules {
  Products = 1,
  Subscriptions = 2,
  BillingHistory = 3,
  PaymentMethods = 4,
  Integrations = 5,
  Cart = 6,
  Invoice = 7,
}
